import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'
import { IAssistanceObject } from 'src/types'

interface IRemoveAssistanceModalProps {
  assistances: any
  remove: (assistance: IAssistanceObject) => Promise<any>
}

interface IRemoveAssistanceModalState {
  isSaving: boolean
}

export default class RemoveAssistanceModal extends React.Component<
  RouteComponentProps<any> & IRemoveAssistanceModalProps,
  IRemoveAssistanceModalState
> {
  constructor(props: any) {
    super(props)
    this.state = {
      isSaving: false
    }
  }

  public render() {
    const assistances = this.props.assistances[this.props.match.params.id]
    const bodyStyle: any = {
      pointerEvents: this.state.isSaving ? 'none' : 'auto',
      opacity: this.state.isSaving ? 0.4 : 1.0
    }
    const setting = { label: assistances ? assistances.type : '', id: assistances ? assistances.id : '' }
    return (
      <div style={bodyStyle}>
        <SettingRemoveModal
          setting={setting}
          settingType='Assistance'
          onRemove={this.onRemove}
          onClose={this.onClose}
        />
      </div>
    )
  }

  private onRemove = () => {
    this.setState({
      isSaving: true
    })
    const device = this.props.assistances[this.props.match.params.id]
    this.props.remove(device).then(
      (result: any) => {
        setTimeout(() => {
          this.setState({
            isSaving: false
          })
          this.onClose()
        }, 100)
      },
      (err: any) => {
        setTimeout(() => {
          this.setState({
            isSaving: false
          })
          this.onClose()
        }, 100)
      }
    )
  }

  private onClose = () => {
    this.props.history.push('/global-settings/assistance')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveAssistanceModal.tsx